/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_TuesdayInputs */

const en_coach_day_tuesday = /** @type {(inputs: Coach_Day_TuesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday`)
};

const de_coach_day_tuesday = /** @type {(inputs: Coach_Day_TuesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstag`)
};

/**
* | output |
* | --- |
* | "Tuesday" |
*
* @param {Coach_Day_TuesdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_tuesday = /** @type {((inputs?: Coach_Day_TuesdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_TuesdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_tuesday(inputs)
	return de_coach_day_tuesday(inputs)
});